import { useEffect, useState, useRef } from "react"
import { onEventListener, offEventListener } from "../aux/internalCommunicationHelpers";

export const useDetectDrag = ( preventClickAfterDrag, attachingEventToDragObject=false ) => {
    const [isDragged, setIsDragged] = useState(false);
    const [dragRef, setDragRef] = useState(null);
    
    useEffect(() => {
        if(dragRef){
            let dragTarget;
            let dragging;
            const captureClick = (e) => {
                e.stopPropagation();
                offEventListener('click', captureClick, attachingEventToDragObject ? dragRef : undefined);
            }
            const dragMove = (e) => {
                if(dragTarget){
                    e.stopPropagation();
                    setIsDragged(true);
                    dragging = true;
                }
            };
            const dragStop = (e) => {
                if(dragging){
                    e.stopPropagation();
                    if(preventClickAfterDrag){
                        onEventListener('click', captureClick, attachingEventToDragObject ? dragRef : undefined);
                    }
                }
                offEventListener('pointerup', dragStop, attachingEventToDragObject ? dragRef : undefined);
                offEventListener('pointermove', dragMove, attachingEventToDragObject ? dragRef : undefined);
                dragTarget = null;
                setIsDragged(false);
                dragging = false;
            };
            const dragStart = (e) => {
                dragTarget = e.currentTarget;
                onEventListener('pointerup', dragStop, attachingEventToDragObject ? dragRef : undefined);
                onEventListener('pointermove', dragMove, attachingEventToDragObject ? dragRef : undefined);
            }
            onEventListener('pointerdown', dragStart, attachingEventToDragObject ? dragRef : undefined);
            return(() => {
                offEventListener('pointerdown', dragStart, attachingEventToDragObject ? dragRef : undefined)
            })
        }
    },[dragRef])

    return [isDragged, setDragRef]
}